<script setup lang="ts">
import { defineComponent, ref, useSlots, watch } from "vue";

const accordionState = ref(false)
const emit =  defineEmits(['opened'])

emit('opened', accordionState)
const toggle = (e?: any) => {
  accordionState.value = !accordionState.value
}

watch(accordionState, () => {
  emit('opened', accordionState)
})

const slots = useSlots()

const trigger = defineComponent({
  render: () => {
    const trigger = slots.default?.()[0];
    if (!trigger) {
      return
    }
    if (!trigger.props) {
      trigger.props = {}
    }
    trigger.props.toggle = toggle;
    trigger.props.state = accordionState;
    return trigger;
  },
});

const content = defineComponent({
  render: () => {
    const content = slots.default?.()[1];
    if (!content) {
      return
    }
    if (!content.props) {
      content.props = {}
    }
    content.props.state = accordionState;
    return content;
  },
});

</script>

<template>
  <article class="accordion" :class="accordionState? 'accordion-active': ''">
    <trigger />
    <content />
  </article>
</template>

<style scoped lang="scss">
.accordion {
  display: block;
  transition: 0.3s all;
  border-radius: 32px;
  background: var(--color-mono-50);

  &:hover {
    background: var(--color-mono-100);
  }

  @media screen and (max-width: 800px) {
    border-radius: 24px;
  }

  &-active {
    padding-bottom: 40px;
    @media screen and (max-width: 800px) {
      padding-bottom: 20px;
    }
  }
}
</style>